// The host podium (lectern) beside the screen. Primitive prop — swappable
// for a GLB later. Decoration only: not collidable.

import React from 'react';
import { PODIUM_TOP, PODIUM_X, PODIUM_Z } from './triviaLayout';

const BODY = '#1b1f26';
const FACE = '#5a1424';
const TRIM = '#b8862e';
const deco = { collidable: false };

export function TriviaPodium() {
  return (
    <group position={[PODIUM_X, 0, PODIUM_Z]}>
      {/* Body, slightly tapered */}
      <mesh position={[0, (PODIUM_TOP - 0.06) / 2, 0]} castShadow receiveShadow userData={deco}>
        <boxGeometry args={[0.7, PODIUM_TOP - 0.06, 0.5]} />
        <meshStandardMaterial color={BODY} roughness={0.55} />
      </mesh>
      {/* Front panel (faces the audience, +Z) */}
      <mesh position={[0, PODIUM_TOP * 0.55, 0.252]} userData={deco}>
        <planeGeometry args={[0.58, PODIUM_TOP * 0.6]} />
        <meshStandardMaterial color={FACE} roughness={0.7} />
      </mesh>
      <mesh position={[0, PODIUM_TOP * 0.55 + PODIUM_TOP * 0.3 + 0.02, 0.253]} userData={deco}>
        <planeGeometry args={[0.58, 0.025]} />
        <meshStandardMaterial color={TRIM} roughness={0.35} metalness={0.7} />
      </mesh>
      {/* Slanted reading top */}
      <mesh position={[0, PODIUM_TOP - 0.02, -0.02]} rotation={[0.25, 0, 0]} castShadow userData={deco}>
        <boxGeometry args={[0.8, 0.05, 0.58]} />
        <meshStandardMaterial color={TRIM} roughness={0.4} metalness={0.6} />
      </mesh>
      {/* Base */}
      <mesh position={[0, 0.03, 0]} receiveShadow userData={deco}>
        <boxGeometry args={[0.85, 0.06, 0.62]} />
        <meshStandardMaterial color={BODY} roughness={0.6} />
      </mesh>
    </group>
  );
}

export default TriviaPodium;
